/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.tw1

import io.kvision.form.upload.UploadInput
import io.kvision.html.Button
import io.kvision.modal.Alert
import io.kvision.modal.Confirm
import io.kvision.redux.createReduxStore
import io.kvision.utils.getContent
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import pl.finn.forms.*

object Tw1Model : CoroutineScope by CoroutineScope(Dispatchers.Default + SupervisorJob()) {

  val formsService = FormsService()
  val tw1Service = Tw1Service()

  val formularzStore =
    createReduxStore(
      ::formularzReducer,
      Formularz(FormularzWidok.PUSTY)
    )

  fun nowy(token: String, app: App) {
    launchWithProgress {
      val formData = tw1Service.nowy(token)
      formularzStore.dispatch(FormularzAction.Nowy(formData))
      app.aktywujtw1()
      window.scrollTo(0.0, 0.0)
    }
  }

  fun sprawdz(form: Tw1Form) {
    val state = formularzStore.getState()
    launchWithProgress {
      val res = tw1Service.sprawdz(form, state.zalaczniki ?: emptyList(), state.token!!)
      println(res)

      Alert.show(
        "Sprawdzenie zgodności dokumentu ze schematem xsd",
        if (res.length < 5) "Dokument jest zgodny ze schematem xsd" else "Dokument zawiera niepoprawne dane.<br/>Należy poprawić pola oznaczone na czerwono.",
        rich = true
      )
    }
  }

  fun zapisz(form: Tw1Form, validateResult: String?) {
    val state = formularzStore.getState()
    launchWithProgress {
      val url = tw1Service.zapisz(form, state.zalaczniki ?: emptyList(), validateResult, state.token!!)
      window.location.href = url
    }
  }

  fun podglad(form: Tw1Form, button: Button) {
    launchWithProgress {
      val state = formularzStore.getState()
      val xml = tw1Service.podglad(form, state.zalaczniki ?: emptyList(), state.token!!)
      PodgladWindow(state.token).pokazTresc(xml, button)
    }
  }

  fun edycja(token: String, app: App) {
    launchWithProgress {
      val formData = tw1Service.edycja(token)
      formularzStore.dispatch(FormularzAction.Edycja(formData))
      app.aktywujtw1()
      window.scrollTo(0.0, 0.0)
    }
  }

  fun anuluj() {
    launchWithProgress {
      val state = formularzStore.getState()
      val url = formsService.anuluj(state.token!!)
      window.location.href = url
    }
  }

  fun dodajZalacznik(zalacznik: UploadInput, opisZalacznika: String?, form: Tw1Form) {
    launchWithProgress {
      zalacznik.value?.firstOrNull()?.let {
        val dataContent = zalacznik.getNativeFile(it)?.getContent()
        val parts = dataContent?.split(",")
        val mime = parts?.get(0)?.drop(5)?.dropLast(7)
        val content = parts?.getOrNull(1)
        formularzStore.dispatch(
          FormularzAction.DodajZalacznik(
            Zalacznik(
              it.name,
              opisZalacznika,
              mime,
              content
            ), form
          )
        )
      }
    }
  }

  fun usunZalacznik(nazwa: String, form: Tw1Form) {
    Confirm.show(
      "Potwierdzenie",
      "Czy na pewno usunąć wybrany załącznik?",
      yesTitle = "Tak",
      noTitle = "Nie"
    ) {
      formularzStore.dispatch(FormularzAction.UsunZalacznik(nazwa, form))
    }
  }
}
